<template>
    <v-card
        class="dashboard-card ma-2"
        elevation="4"
    >
        <v-card-title>ACCISURE</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <h5 class="text--secondary">Customers</h5>
            <v-row
                align="center"
                justify="center"
            >
                <v-card
                    @click="$router.push({ name: 'Customers', params: { status: 1} })"
                    class="ma-2 status-stat text-center"
                >
                    <span class="header">Incomplete</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="accisure == null"
                    ></v-progress-circular>
                    <h3
                        class="stat"
                        v-else
                    >{{accisure.incomplete}}</h3>
                </v-card>

                <v-card
                    @click="$router.push({ name: 'Customers', params: { status: 2} })"
                    class="ma-2 status-stat text-center"
                >
                    <span class="header">Complete</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="accisure == null"
                    ></v-progress-circular>
                    <h3
                        class="stat"
                        v-else
                    >{{accisure.complete}}</h3>
                </v-card>

                <v-card
                    @click="$router.push({ name: 'Customers', params: { status: 3} })"
                    class="ma-2 status-stat text-center"
                >
                    <span class="header">Cancelled</span>
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="accisure == null"
                    ></v-progress-circular>
                    <h3
                        class="stat"
                        v-else
                    >{{accisure.cancelled}}</h3>
                </v-card>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
            <v-row
                align="center"
                justify="center"
            >
                <v-card
                    @click="$router.push({ name: 'Companies' })"
                    class="ma-2 status-stat text-center"
                >
                    <span class="header">Companies</span>
                    <br />
                    <v-progress-circular
                        :width="3"
                        class="mt-6"
                        indeterminate
                        size="25"
                        v-if="accisure == null"
                    ></v-progress-circular>
                    <h3
                        class="stat"
                        v-else
                    >{{accisure.companies}}</h3>
                </v-card>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "Accisure",
    data: () => ({
        accisure: null,
        //
    }),
    mounted: function() {
        this.$store
            .dispatch("customers/getAccisureDashboard")
            .then(accisureResponse => {
                this.accisure = accisureResponse;
            });
    },
    components: {
        //
    },
    methods: {
        //--------------------
    }
};
</script>

<style>
</style>